var indentation_default = {
  "indentZero": "_71NRy",
  "indentOne": "D4NFZ",
  "indentTwo": "hB2zg",
  "indentThree": "qmyNg",
  "indentFour": "-biee",
  "indentFive": "LQWOT",
  "indentSix": "_3q6Oa"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
